// extracted by mini-css-extract-plugin
export default {"wrapper":"FTXbGBCY","zoomOutWrapper":"IQ4j3SPh","zoomInWrapper":"rs1ui6SO","zoomOut":"AUVibCee","zoomIn":"wlZvC7kh","disabled":"sDNtOydH"};